<template>
  <div class="autobookpro-page-content">
    <q-header elevated  class="book-order-header bg-white">
        <div class="row justify-center items-center">
        <div class="book-order-header-content">
            <div class="text-center book-order-logo-box q-py-sm">
            <img class="q-pl-sm" src="../../assets/rr-logo.jpg"/>
            </div>
        </div>
        </div>
    </q-header>
    <div class="row" v-if="!surveyComplete">
      <div class="col-md-9 col-12 q-px-sm">
        <p>Thanks for choosing Route Runners!</p>
        <p>The auto transport industry, often seen as simple, actually involves
          complex tasks like coordinating with drivers,
          aligning with client schedules,
          adapting to the changing market prices,
          and creating specific routes for different cars</p>
        <p>At Route Runners, we are constantly striving to improve and excel in these areas.</p>
        <app-editable-input
            :data="surveyNote"
            type="textarea"
            placeholder="Tell us what you think about your transport"
            name="note"
            autogrow
            @input="surveyNote = $event.model"
        />
        <div>
          <q-rating
            v-model="surveyRating"
            size="3.5em"
            color="yellow"
            icon="star_border"
            icon-selected="star"
          />
        </div>
        <div>
          <q-btn
            @click="handleSaveSurvey"
            color="primary"
            label="Submit"
            :loading="saving"
          />
        </div>
      </div>
      <div class="col-md-3 col-12 q-px-sm">
        <p>Order ID: #{{ orderId }}</p>
          <app-book-order-transport-details
            :vehicles="vehicles"
            :transport="transport"
            :origin="origin"
            :destination="destination"
            :hidePriceBox="true"
          />
          <app-order-dispatch-info class="q-mt-md" :dispatch="dispatch" v-if="dispatch.driver" />
      </div>
    </div>
    <div v-else>
      <p>Thanks for submitting the feedback</p>
    </div>
    <div v-if="invalidLink">
      <h3 class="text-negative text-center">Sorry! This request is invalid!</h3>
    </div>
  </div>
</template>

<script>
import graphql from '@client/graphql';
import AppEditableInput from '@client/components/form/editable-input';
import AppBookOrderTransportDetails from '@client/components/book-order/transport-details';
import AppOrderDispatchInfo from '@client/components/cards/dispatch-info';

export default {
  name: 'AppOrderSurvey',
  components: {
    AppEditableInput,
    AppBookOrderTransportDetails,
    AppOrderDispatchInfo
  },
  data() {
    return {
      loading: false,
      invalidLink: false,
      saving: false,

      surveyComplete: false,

      vehicles: [],
      transport: {},
      origin: {},
      destination: {},
      dispatch: {},

      surveyNote: null,
      surveyRating: 0,
      orderId: null
    };
  },
  async mounted() {
    const { token } = this.$route.params;
    if (!token) {
      this.$router.push({ name: 'home' });
      return;
    }

    this.loading = true;

    const response = await this.$apollo.mutate({
      mutation: graphql.mutations.resolveOrderSurveyLink,
      variables: { encryption: token }
    });
    const { resolveOrderSurveyLink: data } = response.data;
    if (!data) {
      this.invalidLink = true;
    } else {
      this.orderId = data.id;
      this.vehicles = data.vehicles;
      this.transport = data.transport;
      this.origin = data.origin;
      this.destination = data.destination;
      this.dispatch = data.dispatch;
    }
    this.loading = false;
  },
  methods: {
    async handleSaveSurvey() {
      this.saving = true;

      try {
        const { token } = this.$route.params;

        await this.$apollo.mutate({
          mutation: graphql.mutations.submitCustomerSurvey,
          variables: {
            encryption: token,
            surveyNote: this.surveyNote,
            surveyRating: this.surveyRating
          }
        });

        this.surveyComplete = true;
      } catch (error) {
        this.notifyNegative(error.message);
      }

      this.saving = false;
    }
  }
};
</script>

<style></style>
